import React from 'react';
import { AppstoreFilled } from '@ant-design/icons';

const Icon = function (props) {
    return <AppstoreFilled />;
}

export default Icon;